export default "__VITE_ASSET__9d65ec77__"